import * as React from 'react';

import CreditCard16 from './CreditCard16';

export const creditCard16 = () => <CreditCard16 />;

export default {
    title: 'Icon|Fill|CreditCard16',
    component: CreditCard16,
    parameters: {
        notes: "`import CreditCard16 from 'box-ui-elements/es/icon/fill/CreditCard16';`",
    },
};
